const EMAIL_CAMPAIGNS = Object.freeze({
  '/nova27': { campaign: 'direct_invite', content: 'nova27' },
  '/play84': { campaign: 'curiosity', content: 'play84' },
  '/echo51': { campaign: 'early_access', content: 'echo51' },
})

const ATTRIBUTION_PARAMETERS = new Set([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
])

/**
 * Maps durable email short links to the homepage while retaining explicit GA4
 * campaign attribution. Returns null for every non-campaign path.
 *
 * @param {{ pathname?: string }} locationLike
 */
export function emailCampaignLanding(locationLike) {
  const entry = EMAIL_CAMPAIGNS[locationLike.pathname || '']
  if (!entry) return null
  const query = new URLSearchParams({
    utm_source: 'voko_outreach',
    utm_medium: 'email',
    utm_campaign: entry.campaign,
    utm_content: entry.content,
  })
  return `/?${query.toString()}`
}

/**
 * Keeps only non-identifying campaign parameters in analytics page locations.
 * Authentication, preview, search and other query values must never reach GA4.
 *
 * @param {string} search
 */
export function sanitizedAttributionSearch(search) {
  const source = new URLSearchParams(search || '')
  const safe = new URLSearchParams()
  for (const [key, value] of source) {
    if (ATTRIBUTION_PARAMETERS.has(key) && value !== '') safe.set(key, value)
  }
  const query = safe.toString()
  return query === '' ? '' : `?${query}`
}
